import React from "react";
import cn from "classnames";

export const RequiredLabel = ({
  children,
  ...props
}: { children: React.ReactNode } & React.HTMLAttributes<HTMLSpanElement>) => (
  <span className="text-foreground flex items-center gap-1 text-sm font-medium leading-5" {...props}>
    {children}
    <span className="text-destructive">*</span>
  </span>
);

export const RadioDot = ({ selected, className }: { selected: boolean; className?: string }) => (
  <span
    className={cn(
      "flex h-4 w-4 shrink-0 items-center justify-center rounded-full border",
      selected ? "border-[#0f172b] dark:border-slate-300" : "border-border",
      className
    )}
  >
    {selected && <span className="h-2 w-2 rounded-full bg-[#ef2b55]" />}
  </span>
);

/**
 * Inline validation message. Renders with `role="alert"` by default so a
 * Copilot-driven agent (and a screen reader) is told the moment the message
 * appears, rather than having to poll the DOM for it. Pass a caller-supplied
 * `id` and wire it to the field via `aria-describedby` + `aria-invalid` — see
 * `AdmTargetingStep` fields for the pattern. Pass `role={undefined}` for a
 * message nested inside a container that already carries `role="alert"`
 * (avoids double-announcing).
 */
export const FieldError = ({
  message,
  role = "alert",
  ...props
}: { message?: string | null; role?: React.AriaRole } & React.HTMLAttributes<HTMLParagraphElement>) =>
  message ? (
    <p className="mt-1 text-xs text-destructive" role={role} {...props}>
      {message}
    </p>
  ) : null;
